// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
}

.game-results {
  -webkit-user-select: none;
          user-select: none;
}
.game-results .title {
  margin-top: 1.875rem;
  color: #fff;
  font-size: 1.167rem;
  font-weight: bold;
}
.game-results .final-score {
  width: 16.708rem;
  height: auto;
  margin: 3.458rem auto 0.958rem auto;
  border: 0.083rem solid #FBDB55;
  border-radius: 0.625rem;
  position: relative;
}
.game-results .final-score .avatar {
  height: 0;
}
.game-results .final-score .avatar .sec-avatar {
  margin-top: -11.5rem;
}
.game-results .final-score .avatar .box1 {
  position: relative;
  top: 0;
  left: 0;
}
.game-results .final-score .avatar .box1 .image1 {
  position: relative;
  top: -1.8rem;
  pointer-events: none;
}
.game-results .final-score .avatar .box1 .image2 {
  position: absolute;
  top: -3.4rem;
  left: 1.1rem;
  height: 8.125rem;
  width: 5.167rem;
  pointer-events: none;
}
.game-results .final-score .score {
  margin-top: 0.833rem;
  margin-bottom: 0.833rem;
}
.game-results .final-score .score .text {
  color: #fff;
  font-size: 1rem;
}
.game-results .final-score .score .number {
  color: #F5DB6C;
  font-size: 2.5rem;
}
.game-results .final-score .badges {
  position: absolute;
  bottom: -20%;
}
.game-results .final-score .badges .game-bar {
  width: 12.667rem;
  height: 1.708rem;
  background: var(--color-light-blue);
  border-radius: 5rem;
  display: flex;
  margin-top: -2rem;
  margin-left: auto;
  margin-right: auto;
}
.game-results .final-score .badges .game-bar .bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.16rem;
  border-right: 0.042rem solid rgba(0, 0, 0, 0.32);
  gap: 0.167rem;
  text-decoration: none;
}
.game-results .final-score .badges .game-bar .bar .icon {
  width: 1.083rem;
  height: 1rem;
  pointer-events: none;
}
.game-results .final-score .badges .game-bar .bar .icon img {
  width: 100%;
  height: 100%;
}
.game-results .final-score .badges .game-bar .bar .icon-text {
  font-size: 0.867rem;
  color: #003399;
}
.game-results .final-score .badges .game-bar .bar:nth-child(4) {
  border-right: none;
}
.game-results .divider {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  margin-bottom: 1.167rem;
}
.game-results .divider .badge-title {
  color: #fff;
  font-size: 0.967rem;
  text-align: center;
  flex-basis: 40%;
  white-space: nowrap;
}
.game-results .divider .row {
  background-color: #fff;
  width: 35.583rem;
  height: 0.11rem; /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 90%, rgba(255, 255, 255, 0.1) 100%);
}
.game-results .container-fluid {
  width: 39rem;
  margin-right: auto;
  margin-left: auto;
}
.game-results .container-fluid .container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 25, 113, 0.6);
  border-radius: 0.667rem 2.333rem 2.333rem 0.667rem;
  width: 12.667rem;
  min-height: 3rem;
}
.game-results .container-fluid .container .inner-text {
  margin-left: 0.667rem;
}
.game-results .container-fluid .container .inner-text .con-title {
  color: white;
  font-size: 0.833rem;
}
.game-results .container-fluid .container .inner-text .subtitle {
  color: #F5DB6D;
  font-size: 0.6rem;
}
.game-results .container-fluid .container .inner-box {
  display: flex;
}
.game-results .container-fluid .container .inner-box .lock-box {
  border-radius: 4.375rem;
  width: 2.5rem;
  height: 2.5rem;
  text-align: center;
  position: relative;
}
.game-results .container-fluid .container .inner-box .lock-box img {
  width: 2.5rem;
  height: 2.5rem;
  pointer-events: none;
}
.game-results .container-fluid .container .inner-box .lock-box .anime-icon {
  position: absolute;
  top: -60%;
  left: -60%;
  width: 5.5rem;
  height: 5.5rem;
}
.game-results .container-fluid .container .inner-box .mini-box {
  margin-left: -0.5rem;
  background-color: #fff;
  height: 1rem;
  width: 1rem;
  border-radius: 1.875rem;
  z-index: 5;
}
.game-results .container-fluid .container .inner-box .mini-box img {
  width: 1rem;
  height: 1rem;
  pointer-events: none;
}
.game-results .container-fluid .container .inner-box .mini-box.lock {
  background-color: transparent;
}
.game-results .end-game {
  text-align: center;
}
.game-results .end-game .play-btn {
  text-align: center;
  width: 14.333rem;
  height: 2.667rem;
  background-color: #F5DB6C !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  border-radius: 1.333rem;
  font-size: 1rem;
  font-weight: bold;
  color: #003399;
}
.game-results .sidebar {
  margin: auto;
}
.game-results .sidebar .rectangle {
  min-height: 15.042rem;
  background: rgba(51, 102, 204, 0.4);
  border-radius: 0.667rem 0 0 0.667rem;
  padding: 1.875rem 1rem 1.875rem 2rem;
}
.game-results .sidebar .rectangle .group .group-section {
  margin-bottom: 2.458rem;
  display: flex;
  flex-direction: column;
}
.game-results .sidebar .rectangle .group .group-section .group-title {
  line-height: 1.083rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #FFD924;
}
.game-results .sidebar .rectangle .group .group-section .group-text {
  line-height: 1rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #fff;
  margin-top: 0.917rem;
  text-decoration: underline;
}
.game-results .sidebar .rectangle .group .group-section:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/game/game-results/game-results.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;UAAA,iBAAA;AACF;AACE;EACE,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AAEE;EACE,gBAAA;EACA,YAAA;EACA,mCAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,SAAA;AAAN;AAEM;EACE,oBAAA;AAAR;AAGM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AADR;AAGQ;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;AADV;AAIQ;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAFV;AAOI;EACE,oBAAA;EACA,uBAAA;AALN;AAOM;EACE,WAAA;EACA,eAAA;AALR;AAQM;EACE,cAAA;EACA,iBAAA;AANR;AAUI;EACE,kBAAA;EACA,YAAA;AARN;AAUM;EACE,gBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AARR;AAUQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gDAAA;EACA,aAAA;EACA,qBAAA;AARV;AAUU;EACE,eAAA;EACA,YAAA;EACA,oBAAA;AARZ;AAUY;EACE,WAAA;EACA,YAAA;AARd;AAYU;EACE,mBAAA;EACA,cAAA;AAVZ;AAcQ;EACE,kBAAA;AAZV;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAhBJ;AAkBI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,sBAAA;EACA,gBAAA;EACA,eAAA,EACA,aAAA,EACA,4BAAA;EACA,2LAAA;AAjBN;AAqBE;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iCAAA;EACA,kDAAA;EACA,gBAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,qBAAA;AAnBR;AAqBQ;EACE,YAAA;EACA,mBAAA;AAnBV;AAsBQ;EACE,cAAA;EACA,iBAAA;AApBV;AAwBM;EACE,aAAA;AAtBR;AAwBQ;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAtBV;AAwBU;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AAtBZ;AAyBU;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AAvBZ;AA2BQ;EACE,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;AAzBV;AA2BU;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAzBZ;AA6BQ;EACE,6BAAA;AA3BV;AAiCE;EACE,kBAAA;AA/BJ;AAiCI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,8FAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA/BN;AAmCE;EACE,YAAA;AAjCJ;AAmCI;EACE,qBAAA;EACA,mCAAA;EACA,oCAAA;EACA,oCAAA;AAjCN;AAqCQ;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AAnCV;AAqCU;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAnCZ;AAsCU;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;AApCZ;AAwCQ;EACE,gBAAA;AAtCV","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n}\n\n.game-results {\n  user-select: none;\n\n  .title {\n    margin-top: 1.875rem;\n    color: #fff;\n    font-size: 1.167rem;\n    font-weight: bold;\n  }\n\n  .final-score {\n    width: 16.708rem;\n    height: auto;\n    margin: 3.458rem auto 0.958rem auto;\n    border: 0.083rem solid #FBDB55;\n    border-radius: 0.625rem;\n    position: relative;\n\n    .avatar {\n      height: 0;\n\n      .sec-avatar {\n        margin-top: -11.5rem;\n      }\n\n      .box1 {\n        position: relative;\n        top: 0;\n        left: 0;\n\n        .image1 {\n          position: relative;\n          top: -1.8rem;\n          pointer-events: none;\n        }\n\n        .image2 {\n          position: absolute;\n          top: -3.4rem;\n          left: 1.1rem;\n          height: 8.125rem;\n          width: 5.167rem;\n          pointer-events: none;\n        }\n      }\n    }\n\n    .score {\n      margin-top: 0.833rem;\n      margin-bottom: 0.833rem;\n\n      .text {\n        color: #fff;\n        font-size: 1rem;\n      }\n\n      .number {\n        color: #F5DB6C;\n        font-size: 2.5rem;\n      }\n    }\n\n    .badges {\n      position: absolute;\n      bottom: -20%;\n\n      .game-bar {\n        width: 12.667rem;\n        height: 1.708rem;\n        background: var(--color-light-blue);\n        border-radius: 5rem;\n        display: flex;\n        margin-top: -2rem;\n        margin-left: auto;\n        margin-right: auto;\n\n        .bar {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 3.16rem;\n          border-right: 0.042rem solid rgba(0, 0, 0, 0.32);\n          gap: 0.167rem;\n          text-decoration: none;\n\n          .icon {\n            width: 1.083rem;\n            height: 1rem;\n            pointer-events: none;\n\n            img {\n              width: 100%;\n              height: 100%;\n            }\n          }\n\n          .icon-text {\n            font-size: 0.867rem;\n            color: #003399;\n          }\n        }\n\n        .bar:nth-child(4) {\n          border-right: none;\n        }\n      }\n    }\n  }\n\n  .divider {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding-top: 0.5rem;\n    margin-bottom: 1.167rem;\n\n    .badge-title {\n      color: #fff;\n      font-size: 0.967rem;\n      text-align: center;\n      flex-basis: 40%;\n      white-space: nowrap;\n    }\n\n    .row {\n      background-color: #fff;\n      width: 35.583rem;\n      height: 0.11rem;\n      background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 50%, rgba(255, 255, 255, 1) 51%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 0) 100%); /* FF3.6-15 */\n      background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.98) 50%, rgba(255, 255, 255, 1) 51%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 0) 100%); /* Chrome10-25,Safari5.1-6 */\n      background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.4) 10%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.4) 90%, rgba(255, 255, 255, 0.1) 100%);\n    }\n  }\n\n  .container-fluid {\n    width: 39rem;\n    margin-right: auto;\n    margin-left: auto;\n\n    .container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      background: rgba(0, 25, 113, 0.6);\n      border-radius: 0.667rem 2.333rem 2.333rem 0.667rem;\n      width: 12.667rem;\n      min-height: 3rem;\n\n      .inner-text {\n        margin-left: 0.667rem;\n\n        .con-title {\n          color: white;\n          font-size: 0.833rem;\n        }\n\n        .subtitle {\n          color: #F5DB6D;\n          font-size: 0.6rem;\n        }\n      }\n\n      .inner-box {\n        display: flex;\n\n        .lock-box {\n          border-radius: 4.375rem;\n          width: 2.5rem;\n          height: 2.5rem;\n          text-align: center;\n          position: relative;\n\n          img {\n            width: 2.5rem;\n            height: 2.5rem;\n            pointer-events: none;\n          }\n\n          .anime-icon {\n            position: absolute;\n            top: -60%;\n            left: -60%;\n            width: 5.5rem;\n            height: 5.5rem;\n          }\n        }\n\n        .mini-box {\n          margin-left: -0.5rem;\n          background-color: #fff;\n          height: 1rem;\n          width: 1rem;\n          border-radius: 1.875rem;\n          z-index: 5;\n\n          img {\n            width: 1rem;\n            height: 1rem;\n            pointer-events: none;\n          }\n        }\n\n        .mini-box.lock {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .end-game {\n    text-align: center;\n\n    .play-btn {\n      text-align: center;\n      width: 14.333rem;\n      height: 2.667rem;\n      background-color: #F5DB6C !important;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);;\n      border-radius: 1.333rem;\n      font-size: 1rem;\n      font-weight: bold;\n      color: #003399;\n    }\n  }\n\n  .sidebar {\n    margin: auto;\n\n    .rectangle {\n      min-height: 15.042rem;\n      background: rgba(51, 102, 204, 0.4);\n      border-radius: 0.667rem 0 0 0.667rem;\n      padding: 1.875rem 1rem 1.875rem 2rem;\n\n      .group {\n\n        .group-section {\n          margin-bottom: 2.458rem;\n          display: flex;\n          flex-direction: column;\n\n          .group-title {\n            line-height: 1.083rem;\n            font-size: 0.9rem;\n            font-weight: bold;\n            color: #FFD924;\n          }\n\n          .group-text {\n            line-height: 1rem;\n            font-size: 0.9rem;\n            font-weight: bold;\n            color: #fff;\n            margin-top: 0.917rem;\n            text-decoration: underline;\n          }\n        }\n\n        .group-section:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
